import reducer from "./reducer";
export { default as centersSettings } from "./components/index";
export { default as centersSettingsReducerName } from "./constants";
export default reducer;
